<script setup>
import axios from "axios";
import { formatDate } from "@utils/date";
import { computed, ref, watch } from "vue";
import Markdown from "vue3-markdown-it";
import { useRoute } from "vue-router";

import Loading from "@components/global/Loading.vue";

const route = useRoute();
const loading = ref(false);
const page = ref({});
const requestPage = ref(null);
const slug = computed(() => route.params.slug);

function cancelPage() {
  if (requestPage.value) requestPage.value.cancel();
}
function getPage() {
  loading.value = true;
  page.value = {};
  cancelPage();
  let axiosSource = axios.CancelToken.source();
  requestPage.value = { cancel: axiosSource.cancel };
  axios
    .get(`/api/page/${route.params.slug}`, {
      cancelToken: axiosSource.token,
    })
    .then((p) => {
      page.value = p.data;
    })
    .catch((e) => {})
    .finally(() => {
      loading.value = false;
    });
}
getPage();

watch(slug, async () => {
  getPage();
});
</script>

<template>
  <Loading v-if="loading" />
  <section class="container flex w-full flex-col gap-5 lg:w-half" v-else>
    <div class="flex gap-4 items-center uppercase font-medium">
      <div class="border p-1 bg-transparent rotate-45 border-text-base">
        <div class="bg-text-base w-1.5 h-1.5 center"></div>
      </div>
      <p class="md-alt text-text-base text-body-sm">
        Last Updated: {{ formatDate(page.updated_at) }}
      </p>
    </div>
    <svg
      class="w-full"
      xmlns="http://www.w3.org/2000/svg"
      width="1344"
      height="2"
      viewBox="0 0 1344 2"
      fill="none"
    >
      <path
        d="M0 1H1344"
        stroke="white"
        stroke-opacity="0.2"
        stroke-width="1.5"
        stroke-dasharray="2 6"
      />
    </svg>
    <h1
      class="w-full text-purple-600 text-h2 lg:text-display-sm font-heading font-medium uppercase break-words"
    >
      {{ page.title }}
    </h1>
    <Markdown class="markdown" :source="page.body" :breaks="true" />
  </section>
</template>
<style scoped></style>
